import { useQuery } from '@tanstack/react-query';

import { getPromotionCodes } from '@arrived/api_v2';
import { Rewards } from '@arrived/models';

import { UseQueryOptions, UseQueryResult } from '../queries.utils';
import { promotionCodesKeyFn } from './rewards.keys';

export function useGetPromotionCodesQuery(
  promotionUuid?: string,
  options?: UseQueryOptions<Rewards.PromotionCodesSearchResponse>
): UseQueryResult<Rewards.PromotionCodesSearchResponse> {
  return useQuery(promotionCodesKeyFn(promotionUuid!), async () => getPromotionCodes(promotionUuid!), {
    ...options,
    enabled: (options?.enabled ?? true) && promotionUuid != null,
    staleTime: options?.staleTime,
  });
}
